/**
 * Human labels for the role enum values the API returns.
 *
 * Roles arrive as lowercase snake_case ("pi", "data_uploader"). Rendering them
 * through CSS `text-transform: capitalize` produces "Pi" and "Data_uploader",
 * so anywhere a role is shown to a user should go through here instead.
 */
const ROLE_LABELS: Record<string, string> = {
  manager: "Manager",
  pi: "PI",
  researcher: "Researcher",
  data_uploader: "Data uploader",
};

export function roleLabel(role?: string | null): string {
  if (!role) return "";
  const known = ROLE_LABELS[role.toLowerCase()];
  if (known) return known;
  // Unknown role from a newer backend: make it presentable rather than raw.
  return role
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
